import { useState, useCallback } from 'react';

export type SortMode = 'default' | 'distance' | 'category';

const STORAGE_KEY = 'poi-sort-mode';

export function useSortPreference() {
  const [sortMode, setSortModeState] = useState<SortMode>(() => {
    if (typeof window === 'undefined') return 'default';
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'default' || stored === 'distance' || stored === 'category') {
      return stored;
    }
    return 'default';
  });

  const setSortMode = useCallback((mode: SortMode) => {
    setSortModeState(mode);
    localStorage.setItem(STORAGE_KEY, mode);
  }, []);

  return { sortMode, setSortMode };
}
